import * as React from 'react';

import { cssClass } from '../../../style';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { ButtonWidget, ButtonType } from '@tableau/widgets';
import { ACTION_DIALOG_TESTID } from './ContentDetailsDialog';
import { MapDispatchToProps } from '../../utils/ConnectUtils';
import { connect } from 'react-redux';
import { deleteContentsAction } from '../../actions/spaces/DeleteContentAction';
import { bindActionCreators } from 'redux';

const deleteContainer = cssClass('content-detail-section', 'delete-container', {
  paddingTop: 18,
  paddingRight: 6,
  marginLeft: 'auto'
});

interface DeleteContentSectionOwnProps {
  readonly actionMessage: string;
  readonly content: IContentInfo<ExplorableItemType>;
}

interface DeleteContentDispatchProps {
  readonly deleteContent: (items: IContentInfo<ExplorableItemType>[]) => void;
}

export type DeleteContentSectionProps = DeleteContentSectionOwnProps & DeleteContentDispatchProps;

export function DeleteContentSection(props: DeleteContentSectionProps): JSX.Element {
  return (
    <div className={deleteContainer}>
      <ButtonWidget
        buttonType={ButtonType.Destructive}
        children={props.actionMessage}
        testId={`${ACTION_DIALOG_TESTID}-delete-action`}
        handleClick={() => {
          props.deleteContent([props.content]);
        }}
      />
    </div>
  );
}

const mapDispatchToProps: MapDispatchToProps<DeleteContentDispatchProps> = (dispatch) => bindActionCreators({
  deleteContent: deleteContentsAction,
}, dispatch);

export const ConnectedDeleteContentSection: React.ComponentClass<DeleteContentSectionOwnProps> =
  connect(undefined, mapDispatchToProps)(DeleteContentSection);
